 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","13":"location-subnavigation","15":"modal-feedback","16":"modal-feedback-detail-feedback","17":"modal-feedback-error","18":"modal-feedback-simple-select","19":"modal-feedback-success","23":"show-history-page","24":"sign-up","25":"sign-up/app-free-features-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"signup","36":"snow-history-snow-depth","37":"snow-report-page","39":"vendors~leaflet","40":"visual-report-detail-report","41":"visual-report-error","42":"visual-report-simple-select","43":"visual-report-success","44":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"76597b5f96871c560473","2":"e415a49c76ed371a0939","11":"91e4744136023dbf219a","12":"fdc91ca85ea593c7688f","13":"a13d22cc05564e828435","15":"0d31b410b0b9648c7efc","16":"ebf95da82821deaaa4ea","17":"5195afd2ede47ceb0854","18":"2d028c2cfd95d07a3f84","19":"ed6e3ab538f152cab3ad","23":"553c271aae3a21390507","24":"087c36dd686e9cbe864d","25":"87f2ea0eefcec97291ab","26":"be3939be600903d62424","27":"8d67a1d58c947da92eb0","28":"5afd06f1f4ecffe087ca","29":"f5c7170c9c068708109f","30":"ba4cdaef6e8db2d255ba","31":"7127f5d1351177ee326b","32":"cd8e6b15f2c578093b32","33":"7968915850ff5b4a0443","34":"02de94cff090d54d7d60","35":"a2fc851f6eae9b20d7be","36":"14b1b20585b62898fb60","37":"735f1ed9709af50aad7e","39":"2fb66527322f7b161de3","40":"8faad376e29396644012","41":"93943b8072367604c8ef","42":"edfeb788ed9f66ec437f","43":"4d22c5c8b1441837a059","44":"0c2e8491038f64ec834b"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"11":1,"12":1,"15":1,"16":1,"17":1,"18":1,"19":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","13":"location-subnavigation","15":"modal-feedback","16":"modal-feedback-detail-feedback","17":"modal-feedback-error","18":"modal-feedback-simple-select","19":"modal-feedback-success","23":"show-history-page","24":"sign-up","25":"sign-up/app-free-features-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"signup","36":"snow-history-snow-depth","37":"snow-report-page","39":"vendors~leaflet","40":"visual-report-detail-report","41":"visual-report-error","42":"visual-report-simple-select","43":"visual-report-success","44":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"e3b0c44298fc1c149afb","2":"e3b0c44298fc1c149afb","11":"6e4e439ba8a0a8a401ac","12":"d5c242a3b5eda9c89ce1","13":"e3b0c44298fc1c149afb","15":"3450da4492d0fc19c526","16":"ba9ecbc3d83fea4592ef","17":"3452f499dfac52679c8b","18":"1fca309d715eea28656e","19":"1dfd6c590f960ff10a92","23":"e2ca6f19842b5c0891a7","24":"d34fe87da0495cff63cb","25":"f21b398619ef78568f53","26":"50672ce97187f2a5fc8f","27":"5e3dd49ae05b16efd4d0","28":"9c206a8a05288b1c7864","29":"c338e69072a02c0e8933","30":"ec9996d078209306d8be","31":"68799eeba81b4b90f00d","32":"ff9653da7c2f17730dc8","33":"0665dae1d80a192d5de2","34":"0534c8d76a99d40b1173","35":"28a57523b711358dce6e","36":"cb66fb2fd2b34b6f5de2","37":"cb66fb2fd2b34b6f5de2","39":"2e6ddc2d7e6698f3c70d","40":"44757b1d68294caadbb1","41":"b702a7a17b84696b21ed","42":"aa2118b9635ef3a51881","43":"e6d09e0b932c4e93f252","44":"f5268f548c8027735b08"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
